import React, { useEffect } from "react";
import { IoIosAttach } from "react-icons/io";
import OnClickOutside from "../../../../utils/OnClickOutSide";
import { updateSendMessageData } from "../../../../store/Slices/SendMessageSlice";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks";
import { useFile } from "../../../../context/FileProvider";
import { FaFileAlt } from "react-icons/fa";
import { FaRegFileLines } from "react-icons/fa6";
import { useTheme } from "../../../../context/ThemeProvider";
import toast from "react-hot-toast";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/react";
import { FiChevronDown } from "react-icons/fi";
import { VideoAttachIcon } from "../../../../components/icons";
import TextTranslate from "../../../../utils/TextTranslate";
import { updateMessageOptions } from "../../../../store/Slices/MessageOptionsSlice";
import type { ChatDraftKind } from "../../../../context/chatAttachmentTypes";

export default function SelectFile() {
  let dispatch = useAppDispatch();
  let messageData = useAppSelector((state) => state.SendMessageData);
  let CurrentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );
  const { addChatAttachment } = useFile();
  // @ts-ignore
  const { theme } = useTheme();

  const onFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    kind: ChatDraftKind,
  ) => {
    dispatch(
      updateSendMessageData({
        chat_id: CurrentConversationData.chat_id,
      }),
    );

    const list = Array.from(event.target.files || []);
    event.target.value = "";
    if (list.length === 0) return;

    dispatch(
      updateSendMessageData({
        showAttachmentOptions: false,
        message_type: "",
      }),
    );

    for (const fileObj of list) {
      const fileSizeInMB = fileObj.size / (1024 * 1024);
      if (fileSizeInMB > 100) {
        toast.error("File size is greater than 100 MB", { duration: 3000 });
        closeAttachMentOption();
        return;
      }
      addChatAttachment(fileObj, kind);
    }
  };

  function closeAttachMentOption() {
    dispatch(
      updateSendMessageData({
        showAttachmentOptions: false,
      }),
    );
  }


  return (
    <>
      <OnClickOutside
        className="my-auto"
        onClickOutside={closeAttachMentOption}
      >
        <Menu>
          <MenuButton className="inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm/6 font-semibold shadow-2xl focus:outline-none data-[focus]:outline-1">
            <IoIosAttach className="my-auto cursor-pointer text-2xl" />
          </MenuButton>

          <MenuItems
            transition
            anchor="bottom end"
            className="w-[17.2rem] z-50 origin-top-right rounded-xl border border-borderColor text-sm/6 transition duration-200 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
          >
            <MenuItem as="div">
              {(
                { close }, // Destructure `close` from context
              ) => (
                <>
                  <div className="grid h-56 w-[17rem] grid-cols-3 gap-5 rounded-lg bg-primary p-4 px-6 text-sm shadow-md">
                    <label
                      onClick={() => {
                        dispatch(
                          updateSendMessageData({
                            message_type: "doc",
                          }),
                        );
                        close(); // Close the menu when clicked
                      }}
                      htmlFor="documentInput"
                      className="flex h-fit flex-col items-center gap-2"
                    >
                      {/* <input
                        onChange={onFileChange}
                        accept=".pdf,.doc,.docx"
                        className="hidden"
                        type="file"
                        id="documentInput"
                      /> */}
                      <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:opacity-80">
                        {/* <img
                          className="h-7 w-7"
                          src={`${theme == "dark" ? "/AttachIcons/document_dark.png" : "/AttachIcons/document_light.png"} `}
                          alt=""
                        /> */}
                        <div
                          className="theme-colored-icon h-7 w-7"
                          style={{
                            maskImage: `url('${`${theme == "dark" ? "/AttachIcons/document_dark.png" : "/AttachIcons/document_light.png"} `}')`,
                            WebkitMaskImage: `url('${`${theme == "dark" ? "/AttachIcons/document_dark.png" : "/AttachIcons/document_light.png"} `}')`,
                          }}
                        />
                      </div>
                      <div>
                        <TextTranslate text="Document" />
                      </div>
                    </label>
                    <label
                      onClick={() => {
                        dispatch(
                          updateSendMessageData({
                            message_type: "image",
                          }),
                        );
                        close(); // Close the menu when clicked
                      }}
                      htmlFor="photoInput"
                      className="flex h-fit flex-col items-center gap-2"
                    >
                      {/* <input
                        onChange={onFileChange}
                        accept="image/*"
                        className="hidden"
                        type="file"
                        id="photoInput"
                      /> */}

                      <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
                        <div
                          className="theme-colored-icon h-7 w-7"
                          style={{
                            maskImage: `url('${`${theme == "dark" ? "/AttachIcons/gallery_dark.png" : "/AttachIcons/gallery_light.png"} `}')`,
                            WebkitMaskImage: `url('${`${theme == "dark" ? "/AttachIcons/gallery_dark.png" : "/AttachIcons/gallery_light.png"} `}')`,
                          }}
                        />
                      </div>
                      <div>
                        <TextTranslate text="Photo" />
                      </div>
                    </label>
                    <label
                      onClick={() => {
                        dispatch(
                          updateSendMessageData({
                            message_type: "video",
                          }),
                        );
                        close(); // Close the menu when clicked
                      }}
                      htmlFor="videoInput"
                      className="flex h-fit flex-col items-center gap-2"
                    >
                      {/* <input
                        onAbort={() => {
                          // alert("select another file");
                        }}
                        onChange={onFileChange}
                        accept="video/*"
                        className="hidden"
                        type="file"
                        id="videoInput"
                      /> */}

                      <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
                        <VideoAttachIcon className="h-7 w-7 text-themeColor" />
                      </div>
                      <div>
                        <TextTranslate text="Video" />
                      </div>
                    </label>
                    {/* <label
                      onClick={() => {
                        dispatch(
                          updateSendMessageData({
                            message_type: "poll",
                          }),
                        );
                        dispatch(
                          updateMessageOptions({
                            show_create_poll_modal: true,
                          }),
                        );

                        close(); // Close the menu when clicked
                      }}
                      className="flex h-fit flex-col items-center gap-2"
                    >
                      <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
                        <div
                          className="theme-colored-icon h-7 w-7"
                          style={{
                            maskImage: `url('${`${theme == "dark" ? "/AttachIcons/poll_dark.png" : "/AttachIcons/poll_light.png"} `}')`,
                            WebkitMaskImage: `url('${`${theme == "dark" ? "/AttachIcons/poll_dark.png" : "/AttachIcons/poll_light.png"} `}')`,
                          }}
                        />
                      </div>
                      <div>
                        <TextTranslate text="Poll" />
                      </div>
                    </label> */}
                    <label
                      onClick={() => {
                        dispatch(
                          updateSendMessageData({
                            message_type: "location",
                          }),
                        );
                        dispatch(
                          updateMessageOptions({
                            show_send_location_modal: true,
                          }),
                        );

                        close(); // Close the menu when clicked
                      }}
                      className="flex h-fit flex-col items-center gap-2"
                    >
                      <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
                        <div
                          className="theme-colored-icon h-7 w-7"
                          style={{
                            maskImage: `url('${`${theme == "dark" ? "/AttachIcons/location_dark.png" : "/AttachIcons/location_light.png"} `}')`,
                            WebkitMaskImage: `url('${`${theme == "dark" ? "/AttachIcons/location_dark.png" : "/AttachIcons/location_dark.png"} `}')`,
                          }}
                        />
                      </div>
                      <div>
                        <TextTranslate text="Location" />
                      </div>
                    </label>
                    <label
                      onClick={() => {
                        dispatch(
                          updateSendMessageData({
                            message_type: "gif",
                            showGiphyPicker: true,
                            chat_id: CurrentConversationData.chat_id,
                          }),
                        );
                        close(); // Close the menu when clicked
                      }}
                      className="flex h-fit flex-col items-center gap-2"
                    >
                      <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
     
                        <div
                          className="theme-colored-icon h-7 w-6"
                          style={{
                            maskImage: `url('${`${theme == "dark" ? "/DarkIcons/gif.png" : "/LightIcons/gif.png"} `}')`,
                            WebkitMaskImage: `url('${`${theme == "dark" ? "/DarkIcons/gif.png" : "/LightIcons/gif.png"} `}')`,
                          }}
                        />
                      </div>
                      <div>
                        <TextTranslate text="GIF" />
                      </div>
                    </label>
                  </div>
                </>
              )}
            </MenuItem>
          </MenuItems>
        </Menu>

        <div
          className={` ${messageData.showAttachmentOptions
              ? "visible translate-y-3"
              : "pointer-events-none invisible translate-y-20 opacity-0"
            } absolute -right-28 bottom-16 transition-all duration-500 sm:-right-0`}
        >
          <div className="w-70 grid h-28 grid-cols-3 gap-5 rounded-lg bg-primary p-4 px-6 text-sm shadow-md">
            <label
              onClick={() => {
                dispatch(
                  updateSendMessageData({
                    message_type: "doc",
                  }),
                );
              }}
              htmlFor="documentInput"
              className="flex h-fit flex-col items-center gap-2"
            >
              <input
                onChange={(e) => onFileChange(e, "doc")}
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.rtf,.odt,.zip,.rar,.7z,.gz,.tar,.mp3,.m4a,.aac,.ogg,.wav,.flac,.opus,audio/*,application/pdf,application/zip,application/x-zip-compressed"
                className="hidden"
                type="file"
                id="documentInput"
                multiple
              />
              <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:opacity-80">
                <img
                  className="h-7 w-7"
                  src={`${theme == "dark" ? "/AttachIcons/document_dark.png" : "/AttachIcons/document_light.png"} `}
                  alt=""
                />
              </div>
              <div>Document</div>
            </label>
            <label
              onClick={() => {
                dispatch(
                  updateSendMessageData({
                    message_type: "image",
                  }),
                );
              }}
              htmlFor="photoInput"
              className="flex h-fit flex-col items-center gap-2"
            >
              <input
                onChange={(e) => onFileChange(e, "image")}
                accept="image/*"
                className="hidden"
                type="file"
                id="photoInput"
                multiple
              />

              <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
                <img
                  className="h-7 w-7"
                  src={`${theme == "dark" ? "/AttachIcons/gallery_dark.png" : "/AttachIcons/gallery_light.png"} `}
                  alt=""
                />
              </div>
              <div>Photo</div>
            </label>
            <label
              onClick={() => {
                dispatch(
                  updateSendMessageData({
                    message_type: "video",
                  }),
                );
              }}
              htmlFor="videoInput"
              className="flex h-fit flex-col items-center gap-2"
            >
              <input
                onChange={(e) => onFileChange(e, "video")}
                accept="video/*"
                className="hidden"
                type="file"
                id="videoInput"
                multiple
              />

              <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
                <VideoAttachIcon className="h-7 w-7 text-themeColor" />
              </div>
              <div>Video</div>
            </label>
            <div className="flex h-fit flex-col items-center gap-2">
              <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
                <img
                  className="h-7 w-7"
                  src="/AttachIcons/location.png"
                  alt=""
                />
              </div>
              <div>Location</div>
            </div>
            <div className="flex h-fit flex-col items-center gap-2">
              <div className="grid h-14 w-14 cursor-pointer place-content-center rounded-full bg-attachIconBg transition-all duration-300 hover:bg-opacity-55 hover:opacity-80">
                <img
                  className="h-7 w-7"
                  src="/AttachIcons/contact.png"
                  alt=""
                />
              </div>
              <div>Contact</div>
            </div>
          </div>
        </div>
      </OnClickOutside>
    </>
  );
}
